<template>
    <div class="postermerge-bg">
      <div class="content">
        <img class="ech-shake-time" id="poster" :src="poster" alt="合成图片" @touchstart="onTouchstart(poster)" @touchend="onTouchend()">
        <div class="title ech-shake-time-delay">长按海报保存到相册，分享给好友</div>
        <div class="btn-div">
          <van-button
            round
            class="btn button glass"
            icon-position="center"
            to="/"
            color="#1EA6FC"
            >重新制作</van-button
          >
          <van-button
            v-if="showBtn"
            color="#1EA6FC"
            plain
            round
            class="btn button glass"
            icon-position="center"
            url="http://www.zsnews.cn/app/mobile.html"
            >下载中山+新闻客户端</van-button
          >
        </div>
      </div>
    </div>
</template>

<script>
import { computed, ref } from "vue"
import { useRouter } from "vue-router";
import { useStore } from "vuex"
import { Button } from "vant"
import "@/plugins/bridge.js"

export default {
  name: "Statement",
  components: {
    [Button.name]: Button
  },
  setup() {
    const store = useStore()
    const router = useRouter()
    const showBtn = ref(false)
    if (!store.state.poster) {
      router.push("/");
    } 
    const userAgentString = navigator.userAgent.toLowerCase()
    if (userAgentString.indexOf("zsrbapp") < 0) {
      showBtn.value = true
    }

    let loop = null;
    const onTouchstart = (image) => {
      if (userAgentString.indexOf('zsrbapp') >= 0) {
        clearTimeout(loop);
        loop = setTimeout(() => {
            window.ZsrbApp.call("sharePic", {
            title: "高考必胜！一键生成专属海报，为中山考生加油",
            img:  image.replace("data:image/png;base64,",""),
            desc: "高考好彩头来了",
            url: "https://zsrbactivity.zsnews.cn/vue/universityposter/"
          })
        },700);
      }
    }

    const onTouchend = () => {
      clearTimeout(loop);
    }

    return {
      poster: computed(() => store.state.poster), 
      showBtn,
      onTouchstart,
      onTouchend,
    }
  },
  // computed: {
  //   show: {
  //     get() {
  //       return this.$store.state.showPosterMerge
  //     },
  //     set(value) {
  //       this.$store.commit("updateShowPosterMerge", value)
  //     }
  //   }
  // }
}
</script>

<style lang="scss" scoped>
.postermerge-bg {
  width: 100%;
  position: relative;
  background: url("../assets/img/detail_background.png") no-repeat ;
  background-size: cover;
  min-height: 100vh;
  padding-bottom: env(safe-area-inset-bottom);
  padding-top: 4vw;
  .title {
    text-align: center;
    font-size: 3.8vw;
    color: #5E5E5E;
    margin-bottom: 2vw;
  }
  #poster {
    width: 80%;
    // -webkit-touch-callout: none;
  }
  .btn {
    margin: 1vw 0;
    background: #ffffff;
    font-size: 3.8vw;
    width: 260px;
    height: 36px;
  }
  .btn-div {
    padding-bottom: 20px;
  }
}
</style>
